import { createPaginationFilters } from '@/features/admin/helper/createPaginationFilters'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { IdentityUserSearchBy } from '@/generated/Enumerations/IdentityUserSearchBy_pb'
import { IdentityUserSortBy } from '@/generated/Enumerations/IdentityUserSortBy_pb'
import { SearchType } from '@/generated/Enumerations/SearchType_pb'
import {
    IdentityUserFiltersDto,
    IdentityUserFiltersDto_ColumnSearching,
} from '@/generated/Messages/Filters_pb'
import { OmitDeepMessageFields } from '@/types/OmitDeepMessageFields'

const createUserSearching = (
    searchText: string
): OmitDeepMessageFields<IdentityUserFiltersDto_ColumnSearching>[] => [
    {
        searchBy: IdentityUserSearchBy.FIRST_NAME,
        searchText,
        searchType: SearchType.CONTAINS,
    },
    {
        searchBy: IdentityUserSearchBy.LAST_NAME,
        searchText,
        searchType: SearchType.CONTAINS,
    },
    {
        searchBy: IdentityUserSearchBy.EMAIL,
        searchText,
        searchType: SearchType.CONTAINS,
    },
]

export const usersQueryFilters = (
    deletedItemSelection: DeletedItemSelection,
    pageSize: number,
    page: number,
    sortByField: IdentityUserSortBy,
    sortDirectionDesc: boolean,
    searchText: string
): Partial<OmitDeepMessageFields<IdentityUserFiltersDto>> => ({
    deletedItemSelection,
    pagination: createPaginationFilters(pageSize, page),
    sorting: [
        {
            sortBy: sortByField,
            descending: sortDirectionDesc,
        },
    ],
    searching: createUserSearching(searchText.toLowerCase()),
})
